import React from 'react';
import { Button, ButtonProps } from '@mui/material';

/**
 * Primary button component with consistent LogoPulse styling
 * Uses brand colors: neon yellow-green background with dark purple text
 */
export const PrimaryButton: React.FC<ButtonProps> = ({ sx, ...props }) => {
  return (
    <Button
      variant="contained"
      {...props}
      sx={{
        bgcolor: '#DCF995',
        color: '#1B0826',
        fontWeight: 600,
        '&:hover': {
          bgcolor: '#C4E673',
        },
        '&:active': {
          bgcolor: '#A8D142',
        },
        '&.Mui-disabled': {
          bgcolor: '#e0e0e0',
          color: '#999',
        },
        ...sx,
      }}
    />
  );
};
